import { atom, selector } from "recoil";
import { createDataRequest, updateDataRequest, getQuizListRequest, getUserList } from "../../../api/controller/DrawEventController";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";

export const drawEventListState = atom({
    key: 'drawEventListState',
    default: [],
})
export const drawEventQuizState = atom({
	key: 'drawEventQuizState',
	default:{
		data:[],
		ovf:false,
	}
})
export const drawEventUserState = atom({
	key: 'drawEventRestrictedUserState',
	default:{
		data:[],
		ovf:false,
	}
})

export const modalConfigDefault = { size: "lg", wizard: false }

export const filterDrawEventQuizState = atom({
    key: 'filterDrawEventQuizState',
    default: '',
})

export const drawEventFilterState = selector({
    key: 'drawEventFilterState',
    get: ({ get }) => (
        [
            {
                label: 'Quiz',
                size: 6,
                offset: 6,
                required: true,
                type: 'select',
                value: get(filterDrawEventQuizState),
                list: get(drawEventQuizState),
            }
        ]
    ),
    set: ({ set }, e) => set(filterDrawEventQuizState, e)
})

export const formModes = {
    create: [ { name: 'Default Create', action: createDataRequest } ], 
    update: [ { name: 'Default Update', action: updateDataRequest } ],
    view: [ { name: 'Default View' } ],
}

export const drawEventDataStructureState = selector({
    key: 'drawEventDataStructureState',
    get: ({ get }) => (
        [

            { 
                label: 'Quiz',
                type: 'select',
                order: { table: 1, form: 1 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
				list: get(drawEventQuizState),
				getRequest: getQuizListRequest,
            },
			{ 
                label: 'Name',
                type: 'text',
                order: { table: 2, form: 2 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Start Date',
                type: 'datepicker',
                order: { table: 3, form: 3 }, 
				table: { dateFormat: 'MMM Do, YYYY', postDateFormat:'YYYY-MM-DD' },
                create: [{ enabled: true, size: { xs: 12, md: 6 } , dateFormat: 'YYYY-MM-DD', options: { altInput: true, altFormat: 'F j, Y', dateFormat: 'Y-m-d' } }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'End Date',
                type: 'datepicker',
                order: { table: 4, form: 4 }, 
				table: { dateFormat: 'MMM Do, YYYY', postDateFormat:'YYYY-MM-DD' },
                create: [{ enabled: true, size: { xs: 12, md: 6 } , dateFormat: 'YYYY-MM-DD', options: { altInput: true, altFormat: 'F j, Y', dateFormat: 'Y-m-d' } }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Allow Winners',
                type: 'switch',
                order: { form: 5.2 }, 
                create: [{ enabled: true, size: { xs: 12, md: 3 }, subText: "Other Events" }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
				list: ['Yes', 'No'],
            },
			{ 
                label: 'Number Of Draws',
                type: 'number',
                order: { form: 5.1 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }, default: 1 }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
				list: ['Yes', 'No'],
            },
			{ 
                label: 'Automated',
                type: 'switch',
                order: { table: 6, form: 5.3 }, 
                create: [{ enabled: true, size: { xs: 12, md: 3 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
				list: ['Yes', 'No'],
            },
			{ 
                label: 'Draw Time',
                type: 'datepicker',
                order: { form: 6 }, 
				table: { dateFormat: 'MMM Do, HH:mm', postDateFormat:'YYYY-MM-DD HH:mm' },
                create: [{ enabled: true, size: { xs: 12, md: 6 }, validations:'hidden_if:Automated,0' , dateFormat: 'YYYY-MM-DD HH:mm', options: { altInput: true, enableTime: true, time_24hr: true, altFormat: 'F j, Y H:i', dateFormat: 'Y-m-d H:i' } }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Drawn?',
                field: 'drawn',
                type: 'switch',
                order: { table: 8 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
				list: ['Yes', 'No'],
            },
			{ 
                label: 'Restricted Users',
                type: 'multiselect',
                order: { form: 8 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
				list: get(drawEventUserState),
				getRequest: getUserList,
            },
			{ 
                label: 'Winners',
                type: 'multiselect',
                order: { form: 9 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
				list: get(drawEventUserState),
				getRequest: getUserList,
            },

        ].filter((v)=>{
            const page = get(pageState)
            const permissions = get(permissionState)
            if(! v.permission){
                return true
            }
            let absolute = false;
            if(v.permission.substr(0,1) === ":"){
                absolute = true;
                v.permission = v.permission.substr(1)
            }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
})
